<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 m-b-15 text-nomal">기본설정</h3>
		<div class="white-box m-t-15 clearfix" v-if="copy">
			<p class="m-b-10 f-14">복사할 강좌 검색</p>
			<div class="search-box full-width m-b-5">
				<input id="search" class="form-control round full-width m-b-0" type="text" autocomplete="off" v-model="lecSearch" placeholder="강좌명으로 검색할 수 있습니다.">
				<label for="search">검색</label>
				<select class="form-control full-width round text-left" v-model="lecSelected" @change="setDefaultLec(lecSelected)">
					<option v-if="classes.filter(c=>c.lecName.indexOf(lecSearch)>=0).length==0" :value="null">검색된 강좌가 없습니다.</option>
					<option v-if="classes.filter(c=>c.lecName.indexOf(lecSearch)>=0).length>0" :value="null">=== 복사할 강좌를 선택하세요 ===</option>
					<option v-for="(lec, idx) in classes.filter(c=>c.lecName.indexOf(lecSearch)>=0)" :value="lec" :item="lec" :index="idx" :key="'found-lec-list-'+idx+hash(lec)">[{{lec.category}}] {{lec.lecName}}</option>
				</select>
				<!--
				<ul class="search-list" :style="(lecSearch&&!lecSelected)?'display:block':''">
					<li v-for="(lec, idx) in classes.filter(c=>c.lecName.indexOf(lecSearch)>=0)" :item="lec" :index="idx" :key="'found-lec-list-'+idx+hash(lec)">
						<a @click="setDefaultLec(lec)">[{{lec.category}}] {{lec.lecName}}</a>
					</li>
					<li v-if="classes.filter(c=>c.lecName.indexOf(lecSearch)>=0).length==0">
						<a>검색된 강좌가 없습니다.</a>
					</li>
				</ul>
				-->
			</div>
		</div>
		<div class="white-box m-t-30 clearfix">
			<p class="f-14">
				<img src="images/s-check2.png" alt="">
				강좌 분류
			</p>
			<select class="w220 form-control-sm round m-b-0 m-r-5 pull-left" v-model="categoryParent">
				<option value="">==== 강좌 분류를 선택하세요 ====</option>
				<option v-for="(category, index) in categories" :key="'category-parent-'+hash(category)" :value="index">{{category.name}}</option>
			</select>
			<select class="w220 form-control-sm round m-b-0 m-r-5 pull-left" v-model="categoryChild" v-if="categories[categoryParent] && categories[categoryParent].childs">
				<option value="">하위 강좌 분류 선택하지 않음</option>
				<option v-for="(category, index) in categories[categoryParent].childs" :key="'category-child-'+hash(category)" :value="index">{{category.name}}</option>
			</select>
			<!--
			<p class="w200 bg-darkgray form-control-sm m-b-0 pull-left text-white round" style="box-sizing: border-box;">
				강의운영 : 온라인
			</p>
			-->
		</div>

		<div class="white-box m-t-30 clearfix">
			<p class="f-14">
				<img src="images/s-check2.png" alt="">
				강좌명
			</p>
			<div class="round on-border">
				<input class="half-width form-control-sm m-b-0 no-border text-left pull-left" type="text" placeholder="강의명 입력" v-model="lecData.lecName">
				<span class="pull-right m-r-5 text-lightgray">{{lecData.lecName.length}} / 30</span>
			</div>
		</div>

		<div class="white-box clearfix">
			<p class="f-14 m-b-10">
				이미지
			</p>
			<div class="img-add">
				<input id="img" type="file" ref="file" @change="upload">
				<label for="img">
					<img :src="lecData.lecIcon?`${originLink}/download/${lecData.lecIcon}`:'http://placehold.it/80x80'" alt="프로그램 메인 이미지">
				</label>
			</div>
			<ul class="img-guide">
				<!-- <li>이미지 등록 가이드1</li> -->
				<!-- <li>이미지 등록 가이드2</li> -->
				<!-- <li>이미지 등록 가이드3</li> -->
				<!-- <li>이미지 등록 가이드4</li> -->
			</ul>
		</div>
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep(lecData)">저장하고 넘어가기</button>
	</div>
</template>

<script>
import server from '../../statics/server.js'
import axios from 'axios'

export default {
	name: "SubviewClassRegisterStep_0",

	data: function() {
		return {
			lecData: {
				lecName: this.classData.lecName,
				lecIcon: this.classData.lecIcon,
				categoryId: this.classData.categoryId,
				categoryParent_: this.classData.categoryParent_,
				categoryChild_: this.classData.categoryChild_
			},
			originLink: server.addr(),
			categoryParent: (this.classData.categoryParent_!==null)?this.categories.indexOf(this.classData.categoryParent_):"",
			categoryChild: (this.classData.categoryChild_!==null)?this.categories[this.categories.indexOf(this.classData.categoryParent_)].childs.indexOf(this.classData.categoryChild_):"",
			lecSearch: "",
			classes: [],
			lecSelected: null
		}
	},

	watch: {
		categoryParent: function(newValue) {
			if(newValue==="") {
				this.lecData.categoryId = 0;
				this.lecData.categoryParent_ = null;
			} else {
				this.categoryChild = "";
				this.lecData.categoryId = this.categories[newValue].categoryId;
				this.lecData.categoryParent_ = this.categories[newValue];
				this.lecData.categoryChild_ = null;
			}
		},
		categoryChild: function(newValue) {
			if(newValue==="") {
				this.lecData.categoryId = this.categories[this.categoryParent].categoryId;
				this.lecData.categoryChild_ = null;
			} else {
				this.lecData.categoryId = this.categories[this.categoryParent].childs[this.categoryChild].categoryId;
				this.lecData.categoryChild_ = this.categories[this.categoryParent].childs[this.categoryChild]
			}
		},
		"lecData.lecName": function(newValue, oldValue) {
			if(this.lecData.lecName.length>30) this.lecData.lecName = oldValue;
			else this.lecData.lecName = newValue;
		},
	},

	props: {
		copy: Boolean,
		categories: Array,
		classData: Object,
		default: Object
	},

	mounted: function() {
		axios.post(`${server.addr()}/lecAll`, {}).then( (response) => {
			this.classes = response.data.list;
		});
	},

	methods: {
		setDefaultLec: function(lec) {
			this.$emit("setDefault", lec);
		},
		nextStep: function() {
			if(!this.lecData.categoryId) {
				this.$emit("alert", "강의 분류를 선택하세요.");
				return;
			}
			if(!this.lecData.lecName) {
				this.$emit("alert", "강의명을 입력하세요.");
				return;
			}
			this.$emit("nextStep", this.lecData);
		},
		upload: function() {
			const formData = new FormData();
			formData.append("file", this.$refs.file.files[0]);
			axios.post(`${server.addr()}${server.api.FILE}`, formData).then( (response) => {
				this.lecData.lecIcon = response.data;
			})
		},
	}
}
</script>

<style>

</style>